import React, { FunctionComponent, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import {
  TextField,
  Grid,
  Typography,
  Paper,
  Button,
} from "@material-ui/core";
import * as Yup from "yup";
import { useRoleStyles } from "../useRoleStyles";
import { useStore } from "../../../store";
import { SnackBar } from "../../SnackBar";
import { Select } from "../../Select";

const priorityData = [
  { value: 1, label: "Priority 1" },
  { value: 2, label: "Priority 2" },
  { value: 3, label: "Priority 3" },
  { value: 4, label: "Priority 4" },
  { value: 5, label: "Priority 5" },
  { value: 6, label: "Priority 6" },
];

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  priority: Yup.string().required("Required"),
});

interface RolesProps {
  roleData: any;
  goBackToList: () => void;
}
export const AddRoles: FunctionComponent<RolesProps> = ({
  roleData,
  goBackToList,
}) => {
  const classes = useRoleStyles();
  const [roles, { getRoles, createRole, updateRole }] = useStore("roles");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [roleStatus, setRoleStatus] = useState<string>("");
  const [availabilityFlag, setAvailabilityFlag] = useState<boolean>(false);

  const handleSave = async (values: any) => {
    try {
      const data = {
        name: values.name,
        description: values.description,
        priority_level: values.priority.value
      }
      if (availabilityFlag === false) {
        if (roleData === undefined) {
          await createRole(data);
          await getRoles();
          setSnackbarColor("green");
          setRoleStatus("Role successfully created");
          setTimeout(() => {
            goBackToList();
          }, 2000);
        } else {
          await updateRole(roleData.id, data);
          await getRoles();
          setSnackbarColor("green");
          setRoleStatus("Role successfully updated");
          setTimeout(() => {
            goBackToList();
          }, 2000);
        }
      } else {
        setSnackbarColor("red");
        setRoleStatus("Role Name already exist");
      }
    } catch (error) {
      console.log(error.error);
      setSnackbarColor("red");
      setRoleStatus(error.error);
    }
  };

  const checkAvailability = (value: any) => {
    const names = roles && roles.map((i: any) => i.name);
    const lowercased = names && names.map((name: any) => name.toLowerCase());
    const available = lowercased.includes(value.toLowerCase());
    setAvailabilityFlag(available);
    if (available === true) {
      setSnackbarColor("red");
      setRoleStatus("Role Name already exist");
    }
  };
  const onCloseSnackbar = () => {
    setRoleStatus("");
  };

  return (
    <div >
      <SnackBar
        status={roleStatus}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
      <Paper style={{ minHeight: "25em", minWidth: "50%" }}>
        <Grid item>
          <Formik
            enableReinitialize
            initialValues={
              roleData === undefined
                ? { name: "", description: "", priority: "" }
                : {
                  name: roleData.name, description: roleData.description, priority: priorityData.find(
                    (item: any) => item.value === roleData.priority_level
                  )
                }
            }
            onSubmit={(values, { resetForm }) => {
              console.log(values)
              handleSave(values);
              //resetForm();
            }}
            validationSchema={validationSchema}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form>
                <Grid container direction="row">
                  <Grid item xs>
                    <Grid
                      container
                      spacing={5}
                      className={classes.fieldSpace}
                    >
                      <Grid item xs={6}>
                        <Grid container direction="column">
                          <Typography className={classes.fieldLabelStyles}>
                            Name
                            </Typography>
                          <TextField
                            variant="outlined"
                            inputProps={{ maxLength: 40 }}
                            name="name"
                            type="text"
                            value={values.name}
                            onChange={(e) => {
                              handleChange(e);
                              checkAvailability(e.target.value);
                            }}
                            fullWidth={true}
                          />
                          <ErrorMessage name="name">
                            {(msg) => (
                              <div style={{ color: "red" }}>{msg}</div>
                            )}
                          </ErrorMessage>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container direction="column">
                          <Typography className={classes.fieldLabelStyles}>
                            Description
                            </Typography>
                          <TextField
                            variant="outlined"
                            inputProps={{ maxLength: 80 }}
                            name="description"
                            type="text"
                            value={values.description}
                            onChange={handleChange}
                            fullWidth={true}
                          />
                          <ErrorMessage name="description">
                            {(msg) => (
                              <div style={{ color: "red" }}>{msg}</div>
                            )}
                          </ErrorMessage>
                        </Grid>
                      </Grid>


                      <Grid item xs={6}>
                        <Grid container direction="column">
                          <Typography
                            style={{ textAlign: "left" }}
                            className={classes.fieldLabelStyles}
                          >
                            Priority
                            </Typography>
                          <Select
                            style={{ height: "2em" }}
                            onChange={(value: any) => {
                              console.log(value)
                              setFieldValue("priority", value);
                            }}
                            options={priorityData}
                            value={values.priority}
                          ></Select>
                          <ErrorMessage name="priority">
                            {(msg) => (
                              <div style={{ color: "red" }}>{msg}</div>
                            )}
                          </ErrorMessage>
                        </Grid>
                      </Grid>
                      <Grid item xs={6} >
                        <Grid
                          container
                          direction="row"
                          spacing={1}
                          justify="flex-end"
                          alignItems="flex-end"
                          className={classes.buttonPosition}
                        >
                          <Grid
                            item
                            xs={6}
                            sm="auto"
                            className={classes.buttonStyle}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              type="reset"
                              size="medium"
                            >
                              <Typography>Clear</Typography>
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm="auto"
                            className={classes.buttonStyle}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                              size="medium"
                            >
                              <Typography>Submit</Typography>
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Paper>
    </div>
  );
};